<script lang="ts">
	import { onMount } from 'svelte';
	import { browser } from '$app/environment';
	import { t, type Language } from '$lib/i18n';
	import { captureEvent } from '$lib/analytics/posthog';

	interface Props {
		lang: Language;
	}

	let { lang }: Props = $props();
	let tr = $derived(t(lang));

	let show = $state(false);
	let closing = $state(false);

	onMount(() => {
		if (browser) {
			const consent = localStorage.getItem('cookie-consent');
			if (!consent) {
				show = true;
			}
		}
	});

	function accept() {
		closing = true;
		localStorage.setItem('cookie-consent', 'accepted');
		window.dispatchEvent(new CustomEvent('cookie-consent', { detail: 'accepted' }));
		// Capture after consent is given and PostHog initialises
		setTimeout(() => {
			captureEvent('cookie_consent_given', { action: 'accepted' });
			show = false;
		}, 300);
	}

	function decline() {
		closing = true;
		localStorage.setItem('cookie-consent', 'declined');
		window.dispatchEvent(new CustomEvent('cookie-consent', { detail: 'declined' }));
		setTimeout(() => {
			show = false;
		}, 300);
	}
</script>

{#if show}
	<div
		class="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 transition-all duration-300 {closing
			? 'opacity-0 translate-y-4'
			: 'opacity-100 translate-y-0'}"
	>
		<div class="max-w-4xl mx-auto">
			<div class="glass-strong rounded-2xl p-6 shadow-2xl border border-white/10">
				<div class="flex flex-col md:flex-row md:items-center gap-4">
					<div class="flex-1">
						<p class="text-slate-200 font-medium mb-1">{tr('cookie_title')}</p>
						<p class="text-sm text-slate-400">
							{tr('cookie_description')}
							<a href="/{lang}/privacy" class="text-ameta-green hover:underline"
								>{tr('cookie_privacy_link')}</a
							>.
						</p>
					</div>
					<div class="flex gap-3">
						<button
							onclick={decline}
							class="px-4 py-2 text-sm font-medium text-slate-400 hover:text-slate-200 transition-colors"
						>
							{tr('cookie_decline')}
						</button>
						<!-- svelte-ignore a11y_autofocus -->
						<button
							onclick={accept}
							autofocus
							class="px-5 py-2 bg-ameta-green text-slate-950 rounded-lg text-sm font-semibold hover:bg-ameta-green-light transition-colors"
						>
							{tr('cookie_accept')}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
{/if}
